<div class="main-container">
  <br />
  <div class="alert-box">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path
        d="M23.9996 18V26M23.9996 34H24.0196M20.5796 7.72004L3.63955 36C3.29029 36.6049 3.10549 37.2906 3.10353 37.9891C3.10158 38.6875 3.28254 39.3743 3.62841 39.9811C3.97428 40.5879 4.473 41.0935 5.07497 41.4477C5.67693 41.802 6.36115 41.9924 7.05955 42H40.9396C41.638 41.9924 42.3222 41.802 42.9241 41.4477C43.5261 41.0935 44.0248 40.5879 44.3707 39.9811C44.7166 39.3743 44.8975 38.6875 44.8956 37.9891C44.8936 37.2906 44.7088 36.6049 44.3596 36L27.4196 7.72004C27.063 7.13226 26.561 6.64628 25.9619 6.30901C25.3629 5.97174 24.687 5.79456 23.9996 5.79456C23.3121 5.79456 22.6362 5.97174 22.0372 6.30901C21.4381 6.64628 20.9361 7.13226 20.5796 7.72004Z"
        stroke="#C00F0C"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>

  <div class="main-text">
    <span class="attention">Acción requerida: </span
    ><span
      >Inicia sesión en el Rincón del Consultor en un plazo de 72 horas para revisar y firmar
      electrónicamente tu Solicitud y Acuerdo del Consultor independiente (aparecerá un mensaje con
      un enlace).</span
    >
    <br />
    <br />
    <span>
      Necesitarás tu ID de Consultor (mencionado anteriormente), así como la contraseña que
      ingresaste al comienzo de este proceso para iniciar sesión.
    </span>
  </div>
  <div class="py-3 d-flex flex-wrap justify-content-center mt-3 mb-3">
    <div class="link-box">
      <a
        aria-label="Consultant Corner"
        target="_blank"
        href="https://mycorner.princesshouse.mx/es-MX/home"
        class="link-highlight"
      >
        Iniciar sesión
      </a>
    </div>
  </div>
</div>
